import React from "react";
import { Link } from "react-router-dom";

const CellLink = ({ data }) => {
    let css = "";
    if (data.type === "Primary") {
        css =
            'bg-skin-primary flex justify-center gap-2 py-2 px-8 text-white rounded-full w-full md:w-2/3 font-semibold text-center'
    };
    if (data.type === "Secondary") {
        css =
            'bg-skin-secondary flex justify-center gap-2 border-skin-secondary py-2 px-8 text-white rounded-full w-full md:w-2/3 font-semibold text-center'
    };
    if (data.type === "Default") {
        css =
            'py-2 px-8 text-skin-primary flex justify-center gap-2 rounded-full w-full md:w-2/3 font-semibold text-center'
    };
            
    const gaTrackClick = (data) => {
        if (data.gaTracking && app.tracking) {            
            const clickvalue = data.attributes["data-webm-clickvalue"];
            const section = data.attributes["data-webm-section"];
            app.tracking.sendGaClick(section, clickvalue, data);
        }
        return true;
    }    

    if (data.isExternal) {
        return (
            <a className={css} {...data.attributes} href={data.url} target={data.target} onClick={()=>gaTrackClick(data)} >
                {data.text}
                {data.postImageUrl && <img src={data.postImageUrl} />}
            </a>
        );
    }
    return (
        <Link className={css} {...data.attributes} to={data.url} replace={true}>
            {data.text}
            {data.postImageUrl && <img src={data.postImageUrl} />}
        </Link>
    );
};

export default CellLink;
